module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Black.cd4f1d17.eot";